export const followersType = {
    instagram: "FOLLOWERS",
    youtube: "SUBSCRIBERS",
    tiktok: "FOLLOWERS"
}